/* De Leville — the bag badge: refresh it on EVERY cart change, and let it read on the night page.
   Added 7 Oct 2026. Two bugs, both reported by Eliau, both reproduced before writing this.

   1. THE COUNT GOES STALE WHEN YOU REMOVE SOMETHING.
      The theme already has window.updateCartCount(), and it correctly hides the badge at zero.
      It is simply never called except after an ADD: all seven call sites in snc-sections.js sit
      inside add-to-cart handlers. Empty the bag in the drawer and the badge keeps the old number
      until the next page load. Measured: cart.js item_count 0, badge still showing 3, on the
      Mezza Luna page AND on an ordinary collection page, so it is site-wide.
      Fix: watch the cart endpoints themselves rather than any one button, so every path that can
      change the cart (drawer remove, quantity, clear, add, a future surface) refreshes the badge.

   2. ON THE NIGHT PAGE THE BAG DISAPPEARS AND ONLY THE NUMBER IS LEFT.
      The badge is a BLACK disc with white text. Against the Mezza Luna sky it is invisible, and
      measured, it covers 35% of the bag icon. So you read a floating "3" and no bag.
      Fix: on body.ml-sky only, invert it to a white disc with dark text. Same shape, same place,
      and the bag behind it stays legible because the disc now reads as a disc.

   ⛔ Nothing here touches the theme's own cart logic. It calls the theme's own function. */
(function () {
  'use strict';

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var pending = null;

  function refresh() {
    // coalesce: a drawer remove can fire change + a re-render in the same tick
    clearTimeout(pending);
    pending = setTimeout(function () {
      if (typeof window.updateCartCount === 'function') window.updateCartCount();
    }, 250);
  }

  // fetch
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (CART_WRITE.test(url)) p.then(refresh, function () {});
      return p;
    };
  }

  // XHR: the theme's own cart calls use this, not fetch
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__dlCartWrite = CART_WRITE.test(String(url || ''));
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__dlCartWrite) this.addEventListener('loadend', refresh);
    return _send.apply(this, arguments);
  };

  // belt and braces: Shopify's own event, and coming back to a cached page
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  // the night page needs a disc it can actually see
  var css = document.createElement('style');
  css.id = 'dl-cart-count-night';
  css.textContent =
    'body.ml-sky .custom-header--cart-count{' +
      'background:#fff !important;color:#0b1020 !important;' +
      'box-shadow:0 0 0 2px rgba(11,16,32,.55);font-weight:500;}';
  document.head.appendChild(css);
})();
